<template>
  <section class="content">
    <vue-headful title="QB-STATISTICS | Charts"></vue-headful>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Charts Configuration</h3>
        <div class="box-tools">
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="box-toolbar">
          <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#addChartModal"><i class="fa fa-plus mr-5"></i>Create Chart</button>
          </div>
          <links-box></links-box>
        </div>
        <div class="row">
          <div class="col-sm-6"></div>
          <div class="col-sm-6">
            <div class="dataTables_filter form-inline">
              <label>Search:</label>
              <input type="search" class="form-control input-sm" placeholder aria-controls="users" v-model="filter">
            </div>
          </div>
        </div>
        <b-table :items="items" :fields="fields" :filter="filter">
          <template v-slot:cell(view)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'read')" class="btn btn-default btn-sm" data-toggle="modal" data-target="#editChartModal" @click="updateChart(data.item.id)"><i class="fa fa-pencil mr-5"></i>Bearbeiten</button>
          </template>
          <template v-slot:cell(delete)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'delete')" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#deleteChartModal" @click="deleteChart(data.item.id)"><i class="fa fa-trash mr-5"></i>Löschen</button>
          </template>
        </b-table>
      </div>
    </div>
    <div class="modal fade" id="addChartModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Create Chart</h4>
          </div>
          <ValidationObserver v-slot="{ invalid }">
            <div class="modal-body">
              <div v-if="errorWhileCreating" class="alert alert-danger alert-dismissible">
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true" @click="errorWhileCreating = false">×</button>
                <h4><i class="icon fa fa-warning mr-5"></i>Achtung!</h4>
                Es gibt folgende Fehler:
                <ul>
                  <li v-for="err in Object.keys(errors)">
                    {{err}}: {{typeof errors[err] === 'string' ? errors[err] : errors[err][0] }}
                  </li>
                </ul>
              </div>
              <form class="form-horizontal">
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="chartName" class="control-label col-sm-4">Chart Name:</label>
                    <div class="col-sm-8">
                      <input type="text" id="chartName" placeholder="Chart Name" class="form-control has-error" v-model="newChart.name">
                      <span class="text-danger">{{errors[0]}}</span>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="chartType" class="control-label col-sm-4">Chart Type:</label>
                    <div class="col-sm-8">
                      <input type="text" id="chartType" placeholder="Chart Type" class="form-control" v-model="newChart.type">
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="chartPath" class="control-label col-sm-4">Chart Path:</label>
                    <div class="col-sm-8">
                      <input type="text" id="chartPath" placeholder="Chart Path" class="form-control" v-model="newChart.path">
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="rewriteLabel" class="control-label col-sm-4">Rewrite Label:</label>
                    <div class="col-sm-8">
                      <input type="text" id="rewriteLabel" placeholder="Rewrite Label" class="form-control" v-model="newChart.rewrite_label">
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="orderField" class="control-label col-sm-4">Order Field:</label>
                    <div class="col-sm-8">
                      <input type="text" id="orderField" placeholder="Order Field" class="form-control" v-model="newChart.order_field">
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="chartFilters" class="control-label col-sm-4">Filters:</label>
                    <div class="col-sm-8">
                      <input type="text" id="chartFilters" placeholder="Filters" class="form-control" v-model="newChart.filters">
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="chartQuery" class="control-label col-sm-4">Query:</label>
                    <div class="col-sm-8">
                      <textarea type="text" id="chartQuery" placeholder="Filters" class="form-control" v-model="newChart.query" rows="5"></textarea>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{errors, untouched}">
                  <div :class="['form-group', !untouched ? errors.length > 0 ? 'has-error' : 'has-success' : '']">
                    <label for="chartConfig" class="control-label col-sm-4">Config:</label>
                    <div class="col-sm-8">
                      <textarea type="text" id="chartConfig" placeholder="Config" class="form-control" v-model="newChart.config" rows="5"></textarea>
                    </div>
                  </div>
                </ValidationProvider>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" ref="closeCreate" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Cancel</button>
              <button type="submit" class="btn btn-primary" @click="saveProp">Save<i class="fa fa-save ml-5"></i></button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editChartModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Edit Chart</h4>
          </div>
          <div class="nav-tabs-custom no-margin">
            <ul class="nav nav-tabs pull-right">
              <li class=""><a href="#editMode" data-toggle="tab" aria-expanded="false"><i class="fa fa-pencil mr-5"></i>Edit Mode</a></li>
              <li class="active"><a href="#viewMode" data-toggle="tab" aria-expanded="true"><i class="fa fa-eye mr-5"></i>View Mode</a></li>
            </ul>
          </div>
          <div class="modal-body">
            <div class="tab-content">
              <h4 class="tab-info">Chart: {{chartForUpdate.name}}</h4>
              <div class="tab-pane active" id="viewMode">
                <div class="form-horizontal">
                  <div class="form-group mt-5">
                    <label for="editChartName" class="control-label col-sm-4">Chart Name:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span>{{chartForUpdate.name}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="chartType" class="control-label col-sm-4">Chart Type:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span>{{chartForUpdate.type}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="chartPath" class="control-label col-sm-4">Chart Path:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span>{{chartForUpdate.path}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="rewriteLabel" class="control-label col-sm-4">Rewrite Label:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span>{{chartForUpdate.rewrite_label}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="orderField" class="control-label col-sm-4">Order Field:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span>{{chartForUpdate.order_field}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="chartFilters" class="control-label col-sm-4">Filters:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span>{{chartForUpdate.filters}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="chartQuery" class="control-label col-sm-4">Query:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span style="display:block;overflow-y:scroll;max-height:150px;width:100%">{{chartForUpdate.query}}</span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="chartConfig" class="control-label col-sm-4">Config:</label>
                    <div class="col-sm-8 control-label text-left">
                      <span style="display:block;overflow-y:scroll;max-height:150px;width:100%">{{chartForUpdate.config}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="editMode">
                <!--<div class="alert alert-warning alert-dismissible">
                  <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                  <h4><i class="icon fa fa-warning mr-5"></i>Edit carefully!</h4>
                  Mistakes will be punished with immediate execution ;)
                </div>-->
                <div class="form-horizontal">
                  <div class="form-group mt-5">
                    <label for="editChartName" class="control-label col-sm-4">Chart Name:</label>
                    <div class="col-sm-8">
                      <input type="text" id="editChartName" placeholder="Chart Name" class="form-control" v-model="chartForUpdate.name">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editChartType" class="control-label col-sm-4">Chart Type:</label>
                    <div class="col-sm-8">
                      <input type="text" id="editChartType" placeholder="Chart Type" class="form-control" v-model="chartForUpdate.type">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editChartPath" class="control-label col-sm-4">Chart Path:</label>
                    <div class="col-sm-8">
                      <input type="text" id="editChartPath" placeholder="Chart Path" class="form-control" v-model="chartForUpdate.path">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editRewriteLabel" class="control-label col-sm-4">Rewrite Label:</label>
                    <div class="col-sm-8">
                      <input type="text" id="editRewriteLabel" placeholder="Rewrite Label" class="form-control" :class="isValidJson(chartForUpdate.rewrite_label) ? 'border-green' : 'border-red'" v-model="chartForUpdate.rewrite_label" @change="isValidJson(chartForUpdate.rewrite_label)">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editOrderField" class="control-label col-sm-4">Order Field:</label>
                    <div class="col-sm-8">
                      <input type="text" id="editOrderField" placeholder="Order Field" class="form-control" :class="isValidJson(chartForUpdate.order_field) ? 'border-green' : 'border-red'" v-model="chartForUpdate.order_field" @change="isValidJson(chartForUpdate.order_field)">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editChartFilters" class="control-label col-sm-4">Filters:</label>
                    <div class="col-sm-8">
                      <input type="text" id="editChartFilters" placeholder="Filters" class="form-control" :class="isValidJson(chartForUpdate.filters) ? 'border-green' : 'border-red'" v-model="chartForUpdate.filters" @change="isValidJson(chartForUpdate.filters)">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editChartQuery" class="control-label col-sm-4">Query:</label>
                    <div class="col-sm-8">
                      <textarea type="text" id="editChartQuery" placeholder="Filters" class="form-control" :class="isValidJson(chartForUpdate.query) ? 'border-green' : 'border-red'" v-model="chartForUpdate.query" rows="5" @change="isValidJson(chartForUpdate.query)"></textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="editChartConfig" class="control-label col-sm-4">Config:</label>
                    <div class="col-sm-8">
                      <textarea type="text" id="editChartConfig" placeholder="Config" class="form-control" :class="isValidJson(chartForUpdate.config) ? 'border-green' : 'border-red'" v-model="chartForUpdate.config" rows="5" @change="isValidJson(chartForUpdate.config)"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeEdit"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-primary" @click="saveChartUpdate">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-danger fade" id="deleteChartModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Delete Chart</h4>
          </div>
          <div class="modal-body text-center" v-if="items && chartForDelete !== ''">
            <h3 class="">
              Are you sure you want to delete the Chart "{{items.find(r => {return r.id === chartForDelete}).value}}"?
            </h3>
            <p class="text-bold text-danger"><i class="fa fa-warning mr-5"></i>This change is irreversible!</p>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeDelete"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="submit" class="btn btn-danger" @click="onOk">Delete<i class="fa fa-trash ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import Api from '@/services/Api'
  export default {
    name: "ChartManagement",
    data () {
      return {
        filter: '',
        errorWhileCreating: false,
        fields: [
          {key: 'id', label: 'Chart ID'},
          {key: 'value', label: 'Chart name'},
          {key: 'view', label: 'Edit'},
          {key: 'delete', label: 'Delete'}
        ],
        newChart: {},
        creating: false,
        enableEdit: false,
        chartForDelete:'',
        display: false,
        userPermissions: this.$store.getters.permissions,
        chartForUpdate: {},
        showButton: false,
        selectedProp: '',
        selectedName: '',
        items: [],
        fullOptions: [],
        errors: []
      }
    },
    methods: {
      isValidJson(data) {
        if (data !== [] || {}) {
          try {
            JSON.parse(data)
            return true;
          } catch (e) {
            return false;
          }
        } else {
          return true
        }
      },
      getData () {
        axios.all([Api().get(`/frontend/permission/base`), Api().get(`/statistics/cms/list`)])
          .then(axios.spread((...responses) => {
            this.msOptions = responses[0].data
            this.items = responses[1].data
          })).catch(errors => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
        })
      },
      updateChart (id) {
        Api().get(`/statistics/cms?id=${id}`)
          .then(res => {
            this.chartForUpdate = res.data
          }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
        })
      },
      onOk () {
        Api().delete(`/statistics/cms?id=${this.chartForDelete}`)
          .then(res => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success!',
              text: 'Data deleted successfully'
            });
            Api().get(`/statistics/cms/list`)
              .then(response => {
                this.items = response.data
                this.chartForDelete = ''
                this.$refs.closeDelete.click()
              }).catch(error => {
                this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: 'Error',
                  text: 'Data could not be retrieved'
                });
              })
          })
          .catch(error => {
            this.confirmOpen = false
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
          })
      },
      deleteChart (id) {
        this.chartForDelete = id
      },
      saveProp () {
        Api().post(`/statistics/cms`, this.newChart)
          .then(response => {
            Api().get(`/statistics/cms/list`)
              .then(res => {
                this.$refs.closeCreate.click()
                this.items = res.data
                this.newChart = {}
              }).catch(error => {
              this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: 'Data could not be retrieved'
              });
            })
          })
          .catch(error => {
            this.errorWhileCreating = true
            this.errors = error.response.data.errors || error.response.data.message
          })
      },
      saveChartUpdate () {
        Api().put(`/statistics/cms`, this.chartForUpdate)
          .then(res => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success!',
              text: 'Data updated successfully'
            });
            Api().get(`/statistics/cms/list`)
              .then(res => {
                this.$refs.closeEdit.click()
                this.items = res.data
              }).catch(error => {
              this.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error',
                text: 'Data could not be retrieved'
              });
            })
          }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
        })
      },
      getPermissionsIDs (arr) {
        let retArr = []
        for (let r in arr) {
          for (let a in arr[r]) {
            arr[r][a].forEach(p => {
              if (!retArr.includes(p.id)) {
                retArr.push(p.id)
              }
            })
          }
        }
        return retArr.join(',')
      },
      checkIfDisabled (id, action) {
        if (action in this.userPermissions.role) {
          let a = this.userPermissions['role'][action].find(x => x.value === id || x.value === 'all')
          return typeof a === 'undefined'
        }
        return true
      },
      getPermissions (resource, action) {
        if (this.roleForUpdate.permissions[resource]) {
          return this.roleForUpdate.permissions[resource][action] || []
        }
        return []
      }
    },
    beforeCreate() {
      this.$store.dispatch('userHasPermission', {type: 'role', action: 'create', scope: 'all'})
        .then(res => {
          this.showButton = res
        })
    },
    mounted () {
      this.getData()
    }
  }
</script>
<style>
  .border-green {
    border-width: 4px;
    border-color: green;
  }
  .border-red {
    border-width: 4px;
    border-color: red;
  }
  .nav-tabs .nav-link.active {
    border-color: #dee2e6 #dee2e6 #fff !important;
    color: white;
    background-color: #292a31;
    border-radius: 2px !important;
    border: 1px solid !important;
    border-bottom: #292a31 !important;
  }
  .nav-tabs .nav-item {
    margin-bottom: -3px !important;
  }
  .card-header {
    margin-bottom: 0;
    background-color: rgba(0,0,0,.03);
  }
  .card-header {
    background-color: grey;
    color: black ;
  }
  .nav.nav-tabs.card-header-tabs {
    border-bottom: 1px solid white;
  }
  div.dataTables_filter {
    text-align: right;
  }
  div.dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left;
  }
  div.dataTables_filter input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto;
  }
</style>
